import { pagination_params } from '@/shared/utils/pagination_params';

export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = pagination_params(params);

  params.Descripcion &&
    (path = `${path !== '' ? `${path}&` : ''}Descripcion=${encodeURIComponent(params.Descripcion)}`);
  params.Pantone &&
    (path = `${path !== '' ? `${path}&` : ''}Pantone=${encodeURIComponent(params.Pantone)}`);
  params.Hex && (path = `${path !== '' ? `${path}&` : ''}Hex=${encodeURIComponent(params.Hex)}`);

  return path;
};
